// extracted by mini-css-extract-plugin
export var buttonContainer = "index-module--buttonContainer--1Sr7q";
export var card = "index-module--card--Z+r-l";
export var cardImg = "index-module--cardImg--6L6IW";
export var container = "index-module--container--A6qYS";
export var description = "index-module--description--EhZDx";
export var fullwidthWrapper = "index-module--fullwidthWrapper--8dfca";
export var imageBox = "index-module--imageBox--KN+9k";
export var imageCard = "index-module--imageCard--lCWPF";
export var imageCards = "index-module--imageCards--zkAyZ";
export var joinUsButton = "index-module--joinUsButton--iidBn";
export var label = "index-module--label--TSmqh";
export var textCard = "index-module--textCard--FmmBg";
export var textCards = "index-module--textCards--dcuIm";
export var textOnlyCard = "index-module--textOnlyCard--HtfWa";
export var title = "index-module--title--IuZNB";